import { createApi } from '@core/fetch'

export default {
  //开店阶段首页
  details: createApi('/hms/light/adminApi/merchantTask/openingStageHomePage'),

  //完成开店阶段
  finishOpeningStage: createApi.post(
    '/hms/light/adminApi/merchantTask/finishOpeningStage'
  ),

  //完成新手指引操作
  finishNewGuidelines: createApi.post(
    '/hms/light/adminApi/merchantTask/finishNewGuidelines'
  )
}
